// extracted by mini-css-extract-plugin
export default {"cookieSections":"CookieSettings_cookieSections__hyb8L"};